import {
    Component,
    OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'invoices',
    styleUrls: ['./invoices.component.scss'],
    templateUrl: './invoices.component.pug'
})
export class InvoicesComponent implements OnInit {

    public inv: Invoice[];
    public localState: any;
    constructor(
        public route: ActivatedRoute,
        public translate: TranslateService,
        private http: HttpClient
    ) {
    }

    public ngOnInit() {
        this.http.get(remoteApiHost + 'api/admin/getInvoice').subscribe((data: any) => {
            this.inv = data;
            console.log(this.inv);
        });
    }
}

export interface Invoice {
    invoiceGuid: string;
    numberOfPcs: number;
    period: number;
    amount: number;
    isPaid: boolean;
    created: Date;
}



// WEBPACK FOOTER //
// ./src/app/admin/invoices/invoices.component.ts